import styled from 'styled-components';

export const Container = styled('li')`
  display: flex;
  align-items: flex-end;
  gap: 1rem;

  &[data-sender='client'] {
    flex-direction: row-reverse;
  }

  &[data-is-fullscreen='true'] {
    width: calc(100% - 1.9rem - 42px);

    &[data-sender='client'] {
      align-self: end;
    }
  }
`;

export const Avatar = styled('div')`
  min-width: 32px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;

  &[data-sender='client'] {
    background-color: #ebebeb;
    font-family: 'Poppins Medium';
    font-size: 0.75rem;
    color: #424242;
  }

  &[data-sender='server'] {
    background-color: #e0f3f1;

    svg {
      fill: #00b2a9;
      width: 25px;
    }
    svg > path {
      d: path('M -13 0 h 38 v 24 H 0 Z');
    }
  }
`;

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-family: 'Poppins Medium';
  font-size: 0.75rem;
  font-weight: 500;
  color: #333;
  line-height: 1.25rem;
  padding: 0.75rem;
  border-radius: 4px;
  position: relative;
  //width: calc(100% - 1.9rem - 42px);

  img {
    cursor: pointer;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 0;
    height: 0;
  }

  &[data-sender='server'] {
    align-self: start;
    background-color: #f4f6f6;
    border-bottom-left-radius: 0;

    &:after {
      left: -10px;
      border-bottom: 10px solid #f4f6f6;
      border-left: 10px solid transparent;
    }
  }

  &[data-sender='client'] {
    align-self: end;
    background-color: #ccf0ee;
    border-bottom-right-radius: 0;

    &:after {
      right: -10px;
      border-bottom: 10px solid #ccf0ee;
      border-right: 10px solid transparent;
    }

    .timestamp {
      text-align: right;
    }
  }
`;

export const Timestamp = styled('span')`
  font-size: 0.75rem;
  color: #757575;
`;
